import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, AwardIcon, CheckCircle2Icon } from 'lucide-react';
export function Testimonials() {
  return <section className="py-24 bg-white" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-228">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold font-heading text-navy mb-4" data-id="element-229">
            Trusted by Growing Brands
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex justify-center items-center space-x-1 mb-8" data-id="element-230">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-231" />)}
          </motion.div>
        </div>

        {/* Placeholder Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-232">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-6 rounded-2xl border border-gray-100 flex flex-col items-center justify-center text-center hover:bg-gray-100 transition-colors" data-id="element-233">
            <AwardIcon className="w-10 h-10 text-teal mb-3" data-id="element-234" />
            <span className="font-bold text-navy" data-id="element-235">Shopify Partner</span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gray-50 p-6 rounded-2xl border border-gray-100 flex flex-col items-center justify-center text-center hover:bg-gray-100 transition-colors" data-id="element-236">
            <ShieldCheckIcon className="w-10 h-10 text-teal mb-3" data-id="element-237" />
            <span className="font-bold text-navy" data-id="element-238">Clutch Verified</span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gray-50 p-6 rounded-2xl border border-gray-100 flex flex-col items-center justify-center text-center hover:bg-gray-100 transition-colors" data-id="element-239">
            <StarIcon className="w-10 h-10 text-teal mb-3" data-id="element-240" />
            <span className="font-bold text-navy" data-id="element-241">5-Star Google</span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-gray-50 p-6 rounded-2xl border border-gray-100 flex flex-col items-center justify-center text-center hover:bg-gray-100 transition-colors" data-id="element-242">
            <CheckCircle2Icon className="w-10 h-10 text-teal mb-3" data-id="element-243" />
            <span className="font-bold text-navy" data-id="element-244">99+ Projects</span>
          </motion.div>
        </div>
      </div>
    </section>;
}